var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFatArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 68,
    viewBox: "0 0 84 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6542 34.7564C82.8738 34.5664 83 34.2904 83 34C83 33.7096 82.8738 33.4336 82.6542 33.2436L45.6542 1.24364C45.3582 0.987646 44.9401 0.927831 44.5842 1.09056C44.2283 1.25329 44 1.60867 44 2V19H2C1.44772 19 1 19.4477 1 20V48C1 48.5523 1.44772 49 2 49H44V66C44 66.3913 44.2283 66.7467 44.5842 66.9094C44.9401 67.0722 45.3582 67.0124 45.6542 66.7564L82.6542 34.7564Z",
    fill: "#031D60",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatArrow);
export default __webpack_public_path__ + "static/media/fat-arrow.e99822c41c4458b85578f8125b5757f0.svg";
export { ForwardRef as ReactComponent };